import { useRef } from 'react';
import { ModalProps } from 'types';
import { useOnClickOutside } from '../../hooks';

export const useComponentLogic = ({
	close,
	shouldCloseOnClickOutside,
}: ModalProps) => {
	const ref = useRef<HTMLDivElement>(null);
	useOnClickOutside(ref, close, shouldCloseOnClickOutside);
	return { ref };
};
